import React from 'react'
import { Drawer as VaulDrawer } from 'vaul'

import styles from './drawer.module.scss'

export interface DrawerContentProps {
    ref?: React.Ref<HTMLDivElement>
    children: React.ReactNode
    ariaDescription: string
}

export const DrawerContent: React.FC<DrawerContentProps> = ({ children, ariaDescription, ref }) => {
    return (
        <VaulDrawer.Portal>
            <VaulDrawer.Overlay className={styles['drawer__overlay']} />
            <VaulDrawer.Content ref={ref} className={styles['drawer__content']}>
                <VaulDrawer.Description aria-description={ariaDescription} />

                <div className={styles['drawer__container']}>{children}</div>
            </VaulDrawer.Content>
        </VaulDrawer.Portal>
    )
}
